import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetPresignedDownloadURLForRespondentSpocMappingTemplateRPC } from "./getPresignedDownloadUrlForRespondentSpocMappingTemplateRPC";

export class GetPresignedDownloadURLForRespondentSpocMappingTemplateRPCClientImpl extends GetPresignedDownloadURLForRespondentSpocMappingTemplateRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetPresignedDownloadURLForRespondentSpocMappingTemplateRPC.Request): Promise<LeoRPCResult<GetPresignedDownloadURLForRespondentSpocMappingTemplateRPC.Response, GetPresignedDownloadURLForRespondentSpocMappingTemplateRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "spoc-management/GetPresignedDownloadURLForRespondentSpocMappingTemplate",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetPresignedDownloadURLForRespondentSpocMappingTemplateRPC.ResponseDTO,
      GetPresignedDownloadURLForRespondentSpocMappingTemplateRPC.Errors.ErrorsDTO,
      GetPresignedDownloadURLForRespondentSpocMappingTemplateRPC.Response,
      GetPresignedDownloadURLForRespondentSpocMappingTemplateRPC.Errors.Errors
    >(
      response,
      "spoc-management/GetPresignedDownloadURLForRespondentSpocMappingTemplate",
      GetPresignedDownloadURLForRespondentSpocMappingTemplateRPC.Response.fromDTO,
      GetPresignedDownloadURLForRespondentSpocMappingTemplateRPC.Errors.fromDTO
    );
  }
}
